<!--  -->
<template>
  <van-popup v-model="showPop" class="registerAfter" :close-on-click-overlay="false">
    <h3>恭喜您注册成功，快完善一下考试信息吧</h3>
    <ul>
      <li
        :class="{ active: examNum.name === item.name }"
        v-for="(item, i) in examList"
        :key="i"
        @click="choose(item)"
      >
        {{ item.name }}
      </li>
    </ul>
    <button class="btn" @click="submit">保存</button>
  </van-popup>
</template>

<script>
import { reqNewUserRecord } from '@/api/login';
import { chooseRecordsList } from '@/api/chooseRecords';

export default {
  components: {},
  data() {
    return {
      showPop: false,
      examNum: {},
      // examList: [
      //   // {
      //   //   name: '23考研',
      //   //   key: 19,
      //   // },
      //   // {
      //   //   name: '24考研',
      //   //   key: 233,
      //   // },
      //   // {
      //   //   name: '25考研',
      //   //   key: 901,
      //   // },
      //   // {
      //   //   name: '26考研',
      //   //   key: 1117,
      //   // },
      //   {
      //     name: '27考研',
      //     key: 1331,
      //   },
      //   {
      //     name: '28考研',
      //     key: 1583,
      //   },
      //   {
      //     name: '其他',
      //     key: 0,
      //   },
      // ],
      examList: [],
      point: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    getExamList() {
      chooseRecordsList()
        .then((result) => {
          const kyItem = result.data?.find((item) => item.name === '考研');
          const list = (kyItem?.childLabelTreeVOList || []).map((val) => ({
            name: val.name,
            key: val.id,
          }));
          this.examList = list
        })
        .catch(() => {});
    },
    choose(item) {
      this.examNum = item;
    },
    async submit() {
      if (!this.examNum.name) {
        this.$toast('请选择考试标签');
        return;
      }
      if (this.examNum.key === 0) {
        this.close();
        return;
      }
      if(this.point)return
      this.point=true;
      const { code, msg } = await reqNewUserRecord({
        company: 1,
        labelTreeIdList: [this.examNum.key],
        userCenter: false,
      });
      if (code === 0) {
        this.close();
      } else {
        this.$toast(msg);
      }
      this.point=false
    },
    close() {
      this.showPop = false;
      this.$emit('closeRegisterAfter', true);
    },
  },
  created() {
    this.getExamList();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.registerAfter {
  width: 634px;
  height: 623px;
  background: url('../../assets/img/loginImg/newUserRecord.png') no-repeat;
  background-size: 100%;
  h3 {
    padding: 87px 0 72px 0;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    text-align: center;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 0 0 51px;
    li {
      width: 250px;
      margin: 0 49px 33px 0;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 72px;
      text-align: center;
      background: #fff;
      border: 2px solid #d5d5d5;
      border-radius: 40px;
    }
    li.active {
      color: #fff;
      background: #ff7f41;
      border: 2px solid #ff7f41;
    }
    li:nth-child(2n) {
      margin-right: 0;
    }
  }
  .btn {
    display: block;
    width: 308px;
    height: 80px;
    margin: 100px auto 0;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    background: #ff7f41;
    border-radius: 40px;
  }
}
</style>
